<template>
  <div
    class="searchGeneralGeodir"
    :class="[openSidenav ? isSidenavOpen : isSidenavClose]"
  >
    <TypeAhead
      v-model="data"
      :srcImgLoading="srcImgLoading"
      :classes="classes"
      :placeholder="placeholder"
      :autofocus="autofocus"
      :src="urlGetAutocomplete"
      :getResponse="getResponse"
      :selectFirst="selectFirst"
      :limit="parseInt(limit)"
      :queryParamName="queryParamName"
      :minChars="parseInt(minChars)"
      :delayTime="parseInt(delayTime)"
      :onHit="onHit"
      :highlighting="highlighting"
      :render="render"
      :fetch="fetch"
      :clean="cleanSearchGeneral"
      @keyup.enter.native="update"
    ></TypeAhead>
  </div>
</template>
 
<script>
import axios from "axios";
import TypeAhead from "../templatesComponents/VueSaxGeneralTypeaheadTemplate";

import { mapState, mapMutations } from "vuex";

export default {
  components: {
    TypeAhead,
  },
  data() {
    return {
      urlReverse: "",
      isSidenavOpen: "openSidenav",
      isSidenavClose: "closedSidenav",
      data: "",
      openSidenav: false,
      access_token: "",
      store_ubigeo: this.$store.getters.store_getUbigeo,
      urlGetAutocomplete: "",
      selectFirst: true,
      srcImgLoading: "@/assets/images/loading-two.gif",
      limit: 10,
      queryParamName: ":search",
      minChars: 2,
      delayTime: 0,
      placeholder: "Buscar en Geodir Maps",
      autofocus: "autofocus",
      classes: "typeahead searchGeneralTypeahead",
      builder_map: this.$route.query.mapa,
      dataPlaces: null,
      id: this.$route.params.id,
      nombre: "",
      nombre_etiqueta: "",
      direccion_simple: "",
      geojson: this.$route.params.geojson,
      x: null,
      y: null,
    };
  },

  created() {
    console.log("BUSCADOR GENERAL CREADO");
    this.urlGetAutocomplete = process.env.VUE_APP_PLACES_AUTOCOMPLETE;
    this.access_token = process.env.VUE_APP_TOKEN_APIS;
    this.urlReverse = process.env.VUE_APP_GEOCODING;
  },

  mounted() {
    let app = this;

    //validar sesion
    if (app.checkLogin()) {
      const tokenData = JSON.parse(window.localStorage.getItem("geodir_Token"));
      app.access_token = tokenData.data.access_token;
    }
      //Crear URL para servicio autocomplete
    //app.urlGetAutocomplete= process.env.VUE_APP_URL_PLACES + 'source/poi?&search=:search'+'&access_token='+app.access_token;
    app.urlGetAutocomplete =
      this.urlGetAutocomplete + "&key=" + app.access_token;
    //si se logue validar
    this.$store.watch(this.$store.getters.isLoggedIn, (n) => {
      if (!n) {
        app.access_token = process.env.VUE_APP_TOKEN_APIS;
      }
    });

    this.$store.watch(this.$store.getters.isOpenSidenav, (openSidenav) => {
      app.openSidenav = openSidenav;
    });
    //si tiene latitud y longitud
    if (localStorage.getItem("longitude") != null) {
      this.urlGetAutocomplete =
        this.urlGetAutocomplete +
        "&y=" +
        localStorage.getItem("latitude") +
        "&x=" +
        localStorage.getItem("longitude");
    } else {
      this.urlGetAutocomplete = this.urlGetAutocomplete + "&y=0.0&x=0.0";
    }

    let that = this;

    if (this.$route.params.tipo == "coordinate") {

      console.log('ubicar por coordenadas');

      setTimeout(function () {
        let y = that.$route.params.y;
        let x = that.$route.params.x;
        let z = that.$route.params.z;
        let layerMarker = that.$store.getters.layerMarkerSearcher;

        if (layerMarker) {
          that.map.removeLayer(layerMarker);
        }

        let lat = that.$route.params.nombre.split(",")[0];
        let lng = that.$route.params.nombre.split(",")[1];

        let latlngMap = new L.latLng(y, x);
        that.map.setView(latlngMap, z);

        let latlngMarker = new L.latLng(lat, lng);

        setTimeout(function () {
          that.layerResult = L.marker(latlngMarker).addTo(that.map);
        }, 300);

        that.$store.commit("SET_LAYER_MARKER", that.layerResult);
        that.$store.commit("setQuery", that.$route.params.nombre);
      }, 100);
    }

    if (this.$route.params.tipo == "coordinates") {

      console.log('ubicar por coordenadas');

      setTimeout(function () {
        let z = that.$route.params.z;
        let layerMarker = that.$store.getters.layerMarkerSearcher;

        if (layerMarker) {
          that.map.removeLayer(layerMarker);
        }

        let valueCoordinates = that.$route.params.value.replace(/\s+/g, '');

        let lat = valueCoordinates.split(",")[0];
        let lng = valueCoordinates.split(",")[1];

        let latlngMap = new L.latLng(lat, lng);
        that.map.setView(latlngMap, z);

        let latlngMarker = new L.latLng(lat, lng);

        setTimeout(function () {
          that.layerResult = L.marker(latlngMarker).addTo(that.map);
        }, 300);

        that.$store.commit("SET_LAYER_MARKER", that.layerResult);
        that.$store.commit("setQuery", that.$route.params.value);
      }, 100);
    }



    // }else{
    //   console.log("no esta logueado")
    // }

    
    /*const url = process.env.VUE_APP_URL_PLACES;
    var urlget = url + "findid";

    if (this.$route.params.tipo == "place") {
      axios
        .get(urlget, {
          params: {
            id: this.id,
            access_token: "c7fab301-31d8-4618-b452-bc82e361d9bf",
          },
        })
        .then((response) => {
          console.log("respuesta");
          console.log(response.data);

          this.dataPlaces = response.data;
          this.nombre = this.dataPlaces.map((response) => response.nombre);
          this.nombre_etiqueta = this.dataPlaces.map(
            (response) => response.nombreEtiqueta
          );
          this.direccion_simple = this.dataPlaces.map(
            (response) => response.direccionSimple
          );
          this.geojson = this.dataPlaces.map((response) => response.geojson);

          let y = this.$route.params.y;
          let x = this.$route.params.x;
          let z = this.$route.params.z;

          let layerMarker = this.$store.getters.layerMarkerSearcher;

          if (layerMarker) {
            this.map.removeLayer(layerMarker);
          }

          var latlngt = new L.latLng(y, x);

          this.geojson = JSON.parse(this.geojson);

          this.geojsonLayer = L.geoJson(this.geojson);
          //this.map.fitBounds(this.geojsonLayer.getBounds(),{maxZoom: 18});

          if (this.geojson.type == "Point") {
            let latlngt = new L.latLng(y, x);
            this.map.setView(latlngt, 17);
          }
          if (this.geojson.type != "Point") {
            this.map.fitBounds(this.geojsonLayer.getBounds());
          }

          //this.map.setView(latlngt, z);

          const that = this;

          console.log("DIBUJAR");
          console.log(this.geojsonLayer);

          setTimeout(function () {
            that.geojsonLayer
              .bindPopup(that.nombre_etiqueta.toString(), {
                offset: L.point(12, 7),
                autoPan: false,
              })
              .addTo(that.map)
              .openPopup();
          }, 300);

          this.$store.commit("SET_LAYER_MARKER", this.geojsonLayer);
          this.$store.commit(
            "setQuery",
            this.nombre + " " + this.direccion_simple
          );
        });
		}*/
  },
  computed: {
    ...mapState(["map", "query", "latitud_general", "longitud_general"]),
  },
  watch: {
    query: function (val) {
      this.data = this.query;
    },
    $route: function () {
      this.builder_map = this.$route.query.mapa;
    },
  },
  methods: {
    update() {
      console.log("******************");
      console.log("update");

      let coordinates = this.data;

      if (coordinates.trim().includes(" ")) {
        var code = coordinates.trim().split(" ");
        var lat = code[0];
        var lng = code[1];
      }
      if (coordinates.trim().includes(",")) {
        var code = coordinates.trim().split(",");
        var lat = code[0].trim();
        var lng = code[1].trim();
      }

      this.$store.commit("SET_LATITUD_GENERAL", lat);
      this.$store.commit("SET_LONGITUD_GENERAL", lng);

      if (Number.isInteger(parseInt(lat)) && Number.isInteger(parseInt(lng))) {
        /*this.$router.push({
          name: "coordinate",
          params: {
            tipo: "coordinate",
            nombre: lat + "," + lng,
            y: lat,
            x: lng,
            z: 17,
          },
        });*/
        this.readCoordinates(lat, lng);
      }
    },

    checkLogin() {
      return this.$store.state.isLoggedIn;
    },

    getResponse(response) {
      console.log("RESPUESTA");
      console.log(response);

      return response.data.predictions;
    },

    onHit: function (item, vue, index) {
      console.log("hit");
      console.log(item);

      this._drawPointMarker(item);

      this.$store.commit("setQuery", item.description);

      vue.query = this.query;

      /*let nombre = item.nombre.toLowerCase().split(" ").join("+");
      let y = item.y.toFixed(6);
      let x = item.x.toFixed(6);
      let z = this.map.getZoom();*/

      /*if (this.$route.name == "home") {
        this.$router.push({
          path: `/place/${nombre}/${y}/${x}/${z}/${item.idString}`,
        });
      } else {
        let actualRoute = this.$route.path;
        this.$router.push({
          path: `${actualRoute}/place/${nombre}/${y}/${x}/${z}/${item.idString}`,
        });
      }*/
    },

    _drawPointMarker(item) {
      let layerMarker = this.$store.getters.layerMarkerSearcher;

      let self = this;

      if (layerMarker) {
        this.map.removeLayer(layerMarker);
      }

      // obtener coordenadas
      // place_id

      let urlPlaceDetail =
        process.env.VUE_APP_PLACES_DETAILS +
        `place_id=${item.place_id}&key=${self.access_token}`;

      axios
        .get(urlPlaceDetail)
        .then(function (response) {
          console.log("Se obtuvo el detail correctamente");
          console.log(response);

          self.resultPlaceDetail(response.data);
          //resolve(response.data);
        })
        .catch(function (error) {
          console.log(error);
          //reject(error);
        });

      /*this.geojson = JSON.parse(item.geojson);
      this.geojsonLayer = L.geoJson(this.geojson);

      if (this.geojson.type == "Point") {
        let latlngt = new L.latLng(item.y, item.x);
        this.map.setView(latlngt, 17);
      }
      if (this.geojson.type != "Point") {
        this.map.fitBounds(this.geojsonLayer.getBounds());
      }*/

      /*const that = this;

      setTimeout(function () {
        that.geojsonLayer
          .bindPopup("" + item.nombreEtiqueta, {
            offset: L.point(12, 7),
            autoPan: false,
          })
          .addTo(that.map)
          .openPopup();
      }, 300);

      this.$store.commit("SET_LAYER_MARKER", this.geojsonLayer);*/
    },

    resultPlaceDetail(result) {
      console.log("resultados del place");

      let self = this;
      if (result.status == "OK") {
        console.log("resultado ok");
        var customIcon = new L.Icon({
          iconUrl: require("../../assets/images/icon_marker.png"),
          iconAnchor: [12, 30],
        });

        let coordinates = result.geometry.coordinates;

        self.$store.commit("SET_LATITUD_GENERAL", coordinates.lat);
        self.$store.commit("SET_LONGITUD_GENERAL", coordinates.lon);

        let place_id = result.place_id;
        this.$store.commit("SET_PLACE_ID", place_id);

        let address = result.standard_address;
        this.$store.commit("SET_ADDRESS", address);

        var latlng = L.GeoJSON.coordsToLatLng([
          coordinates.lon,
          coordinates.lat,
        ]);

        self.map.setView(latlng, 18, {
          duration: 1,
        });

        var marker = L.marker(latlng, { icon: customIcon })
          .addTo(self.map)
          .bindPopup(result.standard_address)
          .openPopup();

        this.$store.commit("SET_LAYER_MARKER", marker);
      }
    },

    /*saveSearchInDatabase(item) {
      axios
        .post(process.env.VUE_APP_URL_PLACES + "saveSearch", item, {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: "bearer " + this.access_token,
          },
        })
        .then((response) => {
          console.log(response);

          if (typeof fillIn == "function") {
            fillIn(response);
          } else {
            //Vue.set(fillIn[0], fillIn[1], response.body);
          }
        })
        .catch((error) => {
          if (typeof errorCb === "function") {
            errorCb(error);
          } else {
            console.error(
              "[vue-geocoder-api] GET " +
                uri +
                ' failed: "' +
                error +
                '" on ' +
                this.apiUrl +
                ' (using token "' +
                this.token +
                '")'
            );
          }
        });
    },*/

    readCoordinates(lat, lng) {
      var self = this;

      let layerMarker = this.$store.getters.layerMarkerSearcher;

      if (layerMarker) {
        this.map.removeLayer(layerMarker);
      }

      //  buscar coordenadas reevrse
      var customIcon = new L.Icon({
        iconUrl: require("../../assets/images/icon_marker.png"),
        iconAnchor: [12, 30],
      });

      console.log("buscar reverse");
      let urlSearch = `${this.urlReverse}latlon=${lat},${lng}&key=${this.access_token}`;

      axios.get(urlSearch).then((response) => {
        let dataReverse = response.data;

        if (dataReverse.status == "ZERO_RESULTS") {
          console.log("no hay ningun resultado");
          this.$notify({
            title: "Aviso",
            message: "No se encuentra una direccion para estas coordenadas",
            type: "warning",
          });
          var latlngt = new L.latLng(lat, lng);

          self.map.setView(latlngt, 18, {
            duration: 1,
          });
          // agrgar marcador
          self.marker = L.marker(latlngt, { icon: customIcon })
            .addTo(self.map)
            .openPopup();
        } else {
          let result = dataReverse.results[0];
          var latlngt = new L.latLng(lat, lng);

          self.map.setView(latlngt, 18, {
            duration: 1,
          });

          // agrgar marcador
          self.marker = L.marker(latlngt, { icon: customIcon })
            .addTo(self.map)
            .bindPopup(result.standard_address)
            .openPopup();

          let place_id = result.place_id;
          let address = result.standard_address;

          this.$store.commit("SET_LAYER_MARKER", self.marker);

          this.$store.commit("SET_PLACE_ID", place_id);
          this.$store.commit("SET_ADDRESS", address);
        }
      });

      /*let layerMarker = this.$store.getters.layerMarkerSearcher;

      if (layerMarker) {
        this.map.removeLayer(layerMarker);
      }

      var latlngt = new L.latLng(lat, lng);
      this.map.setView(latlngt, 17);

      const that = this;
      setTimeout(function () {
        that.layerResult = L.marker(latlngt).addTo(that.map);
      }, 300);

      this.$store.commit("SET_LAYER_MARKER", this.layerResult);
      this.$store.commit("setQuery", this.$route.params.nombre);*/
    },

    highlighting: function (item, vue) {
      let valueFinal = "";

      let placeResult = item.main_text; // plaza vea
      let querySearch = vue.query; // plaza

      let regExQuerySearch = new RegExp(querySearch, "gi");
      let resultsSearchRegex = placeResult.match(regExQuerySearch);

      var wordSearched = "";
      if (resultsSearchRegex) {
        wordSearched = resultsSearchRegex[0];
      }

      let replaceMask = `<span class="spanwordSearcher">${wordSearched}</span>`;
      let worFinalName = placeResult.replace(wordSearched, replaceMask);
      //let valueNameSearchedReplaced = valueNameSearched;

      if (typeof item === "object") {
        valueFinal =
          worFinalName +
          " " +
          `<span class="spandirectionSearcher">${item.secondary_text}</span>`;
      } else {
        valueFinal = item;
      }

      return valueFinal;
    },
    render: function (items, vue) {
      let newItem = [...items];

      return newItem;
    },
    fetch: function (url) {
      return axios.get(url);
    },
    cleanSearchGeneral() {
      //this.$router.push('/')
      console.log("rutaS");
      console.log(this.$route);
      console.log(this.$router);
      console.log("enrutar");

      /*if (this.$route.name == "place") {
        console.log("enrutar base");
        this.$router.push("/");
      } else if (this.$route.name == "placedelivery") {
        console.log("enrutar vertical");
        this.$router.push("/delivery");
      } else if ((this.$route.name = "placecoronavirus")) {
        console.log("coronavirus");
        this.$router.push("/coronavirus");
      }*/
      //this._enroutingBase();

      let layerMarker = this.$store.getters.layerMarkerSearcher;

      if (layerMarker) {
        this.map.removeLayer(layerMarker);
      }
    },
    _enroutingBase() {},
  },
};
</script>

<style>
.searchGeneralGeodir {
  top: 10px;
  position: fixed;
  text-align: left;
  transition: 0.22s;
  width: 340px;
  height: 48px;
  background-color: #fff;
  z-index: 1000;
  display: inline-block;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 -1px 0 rgba(0, 0, 0, 0.02);
}

.searchGeneralGeodir ul.typehead {
  margin-top: 0px !important;
  left: -48px !important;
  min-width: 388px !important;
}

@media screen and (max-width: 500px) {
  .searchGeneralGeodir {
    top: 10px;
    position: fixed;
    text-align: left;
    transition: 0.22s;
    height: 48px;
    background-color: #fff;
    z-index: 1000;
    display: inline-block;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 -1px 0 rgba(0, 0, 0, 0.02);
    width: 72%;
    display: inline-block;
  }

  .searchGeneralGeodir ul.typehead {
    margin-top: 0px !important;
    left: -48px !important;
    min-width: 340px !important;
  }
}
/*@media(max-width: 500px) {
	
}*/

.openSidenav {
  left: 378px;
}

.closedSidenav {
  left: 58px;
}

/*.el-input__inner {
		height: 48px !important;
		padding: 0px !important;
		font-size: 15px !important;
	}*/

.el-input__inner::placeholder {
  color: #6c757d !important;
}

/*ul.typehead {
		margin-top: 0px !important;
		left: -48px !important;
	}*/

.searchGeneralTypeahead.isFocus {
  border: none !important;
}

.searchGeneralTypeahead .vs-input--input {
  padding: 9px !important;
}

.searchGeneralTypeahead .el-input__inner {
  border-radius: 0px !important;
  border: none !important;
}

/* Cada elemento de la lista */
.searchGeneralGeodir li.listTypehead {
  font-size: 13px !important;
  color: #333 !important;
}

/* Texto que se ingreso en el buscador resaltado en las respuestas */
.spanwordSearcher {
  font-weight: 500;
  color: #0a0a0a;
}

/* Texto de informacion adicional al place realizado*/
.spandirectionSearcher {
  color: #8c8c8c;
}

.searchGeneralTypeahead.vs-input-primary .vs-input--input:focus {
  border: none !important;
}

.searchGeneralTypeahead .vs-input--input {
  border: none !important;
  height: 48px;
  font-size: 15px;
  padding-right: 45px !important;
}

.searchGeneralGeodir .input-span-placeholder {
  padding-left: 5px !important;
}
</style>


